import React from 'react';
import { Button } from '@design-system/Button';
import { InfoSheet } from '@screens/HealthPages/InfoSheet';
import { INFO_SHEET_CONTENT } from '@/utils/InfoSheet/InfoSheetContent';

interface SymptomsSectionProps {
  symptoms: string[];
}

export const SymptomsSection: React.FC<SymptomsSectionProps> = ({
  symptoms,
}) => (
  <div className="mt-6">
    <div className="flex items-center">
      <h2 className="typography-h3 mr-2">Commonly Linked Symptoms</h2>
      <InfoSheet
        title={INFO_SHEET_CONTENT.linkedSymptoms.title}
        description={INFO_SHEET_CONTENT.linkedSymptoms.description}
      />
    </div>

    <div className="flex flex-wrap max-w-[35rem] mt-6 gap-x-2 gap-y-4">
      {symptoms?.map((symptom, index) => (
        <Button
          key={`${symptom}-${index}`}
          variant="outline"
          size="sm"
          className="dark cursor-default bg-transparent rounded-[0.5rem]"
          disabled={true}
        >
          <p className="text-white">{symptom}</p>
        </Button>
      ))}
    </div>
  </div>
);
